<template>
    <CCard>
        <CCardBody>
            <v-toolbar flat color="white">
                <v-toolbar-title>چک ها</v-toolbar-title>
                <v-spacer></v-spacer>
                <CButton color="info" class="mb-2 ml-2 text-white"
                         @click="addItem">
                    چک جدید
                </CButton>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm4 md4>
                                        <CInput
                                                label="شماره چک"
                                                v-model="editedItem.cheque_number"
                                                :is-valid="validations.cheque_number.isValid"
                                                :invalid-feedback="validations.cheque_number.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <div class="form-group">
                                            <label>تاریخ سر رسید</label>
                                            <date-picker v-model="editedItem.due_date"
                                                         input-format="YYYY-MM-DD HH:mm:ss"
                                                         locale="fa" format="YYYY-MM-DD"
                                                         display-format="jYYYY-jMM-jDD">
                                            </date-picker>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <div class="form-group text-center">
                                            <p>چک دریافتی</p>
                                            <select class="form-control" v-model="editedItem.is_revenue" :disabled="editedItem.cheque_id !== ''">
                                                <option value="1">بله</option>
                                                <option value="0">خیر</option>
                                            </select>                                                        
                                        </div>
                                        <label class="text-danger" v-if="!validations.is_revenue.isValid">{{validations.is_revenue.error}}</label>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <CInput
                                                label="شناسه صیاد"
                                                v-model="editedItem.sayad_number"
                                        />
                                    </v-flex>                                    
                                    <v-flex xs12 sm4 md4>
                                        <CInput
                                                label="بانک"
                                                v-model="editedItem.bank_name"
                                                :is-valid="validations.bank_name.isValid"
                                                :invalid-feedback="validations.bank_name.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <CInput
                                                label="شعبه"
                                                v-model="editedItem.brench"
                                                :is-valid="validations.brench.isValid"
                                                :invalid-feedback="validations.brench.error"
                                        />

                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <div class="form-group">
                                            <label>مبلغ چک</label>
                                            <money v-model="editedItem.price" v-bind="money" dir="ltr"
                                                   class="form-control"/>
                                        </div>                                      
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group text-center">
                                            <p>چک تحویل شخص دیگر شود؟</p>
                                            <select class="form-control" v-model="pay_to_contact_active">
                                                <option value="1">بله</option>
                                                <option value="0">خیر</option>
                                            </select>                                                        
                                        </div>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6 v-show="pay_to_contact_active == '0'">
                                        <div class="form-group">
                                            <label>حساب</label>
                                            <v-autocomplete
                                                    v-model="editedItem.account_id"
                                                    :items="categories.accounts"
                                                    :item-text="(item)=>{return item.name}"
                                                    :item-value="(item)=>{return item.account_id}"
                                                    dense
                                            />
                                            <label class="text-danger" v-if="!validations.account_id.isValid">{{validations.account_id.error}}</label>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 v-show="pay_to_contact_active == '1'">
                                        <div class="form-group">                                            
                                            <CInput
                                                    label="شناسه شخص گیرنده"
                                                    v-model="editedItem.pay_to_contact_id"
                                                    :is-valid="validations.pay_to_contact_id.isValid"
                                                    :invalid-feedback="validations.pay_to_contact_id.error"
                                            />
                                            <contact-searcher v-model="editedItem.pay_to_contact_id"></contact-searcher>
                                        </div>
                                    </v-flex>                                    
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">                                            
                                            <CInput
                                                    label="شناسه شخص"
                                                    v-model="editedItem.contact_id"
                                                    :is-valid="validations.contact_id.isValid"
                                                    :invalid-feedback="validations.contact_id.error"
                                            />
                                            <contact-searcher v-model="editedItem.contact_id"></contact-searcher>
                                        </div>
                                    </v-flex>
                                    <CCol xs12 sm12 md12>
                                      <div class="form-group">
                                        <label>دسته بندی مرتبط</label>
                                        <select class="form-control" v-model="editedItem.payment_category_id">
                                          <option v-bind:value="category.category_id"
                                                  v-bind:key="category.category_id"
                                                  v-for="category in categories.categories">{{category.name}}
                                          </option>
                                        </select>
                                      </div>
                                    </CCol>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                            <CInput
                                                    label="شناسه فاکتور خرید"
                                                    v-model="editedItem.bill_id"
                                                    :is-valid="validations.bill_id.isValid"
                                                    :invalid-feedback="validations.bill_id.error"
                                            />                                                
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                            <CInput
                                                    label="شناسه فاکتور فروش"
                                                    v-model="editedItem.invoice_id"
                                                    :is-valid="validations.invoice_id.isValid"
                                                    :invalid-feedback="validations.invoice_id.error"
                                            />                                                
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group text-center">
                                            <p>پاس شده</p>
                                            <select class="form-control" v-model="editedItem.is_checkout">
                                                <option value="1">بله</option>
                                                <option value="0">خیر</option>
                                            </select>                                                      
                                        </div>
                                        <label class="text-danger" v-if="!validations.is_checkout.isValid">{{validations.is_checkout.error}}</label>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <CTextarea
                                                label="توضیحات"
                                                v-model="editedItem.description"
                                                :is-valid="validations.description.isValid"
                                                :invalid-feedback="validations.description.error"
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="close">
                                انصراف
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                            <CButton color="primary" class="mb-2 ml-2 text-white"
                                     @click="save">
                                ذخیره
                                <CIcon :content="$options.iconsSet.cilSave"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="logDialog" max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">تاریخچه</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="logDialog = false">
                                بستن
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
            <CCard>
                <CCardHeader @click="collapse = !collapse">
                    <CIcon name="cil-justify-center"/>
                    <strong> فیلتر </strong>
                </CCardHeader>
                <CCollapse :show="collapse" :duration="400">
                    <CCardBody>
                        <CRow>
                            <CCol sm="3">
                                <CInput
                                        label="شماره چک"
                                        v-model="filters.cheque_number"
                                />
                            </CCol>
                            <CCol sm="2">
                                <CInput
                                        label="نام بانک"
                                        v-model="filters.bank_name"
                                />
                            </CCol>
                            <CCol sm="1">
                                <label>پاس شده</label>
                                <select class="form-control" v-model="filters.is_checkout">
                                    <option value="1">فعال</option>
                                    <option value="0">غیرفعال</option>
                                </select>
                            </CCol>
                            <CCol sm="1">
                                <label>چک دریافتی</label>
                                <select class="form-control" v-model="filters.is_revenue">
                                    <option value="1">فعال</option>
                                    <option value="0">غیرفعال</option>
                                </select>
                            </CCol>                            

                        </CRow>
                    </CCardBody>
                    <CCardFooter class="text-left">
                        <CButton size="sm" color="primary" class="text-white" @click="applyFilters">
                            <CIcon name="cil-check-circle"/>
                            اعمال
                        </CButton>
                        <CButton size="sm" color="danger" class="text-white mr-1" @click="resetFilters">
                            <CIcon name="cil-ban"/>
                            حذف فیلتر ها
                        </CButton>
                    </CCardFooter>
                </CCollapse>
            </CCard>
            <CRow class="text-left" dir="ltr">
                <CButton color="dark" class="mb-2 ml-2 text-white"
                         v-c-tooltip="'خروجی بصورت فایل PDF'"
                         @click="refreshCheques('pdf')">
                    <CIcon :content="$options.iconsSet.cilFilePdf"/>
                </CButton>
                <CButton color="dark" class="mb-2 ml-2 text-white"
                         v-c-tooltip="'خروجی بصورت فایل اکسل'"
                         @click="refreshCheques('excel')">
                    <CIcon :content="$options.iconsSet.cilFileExcel"/>
                </CButton>
            </CRow>
            <v-data-table
                    :headers="headers"
                    :items="cheques"
                    :options.sync="options"
                    :server-items-length="chequesCount"
                    :footer-props="{
                                'items-per-page-options': [100,25, 50]
                    }"
                    sort-by="cheque_id"
                    sort-desc
                    class="elevation-1">
                <template v-slot:item="{item}">
                    <tr>
                        <td>{{ item.cheque_id }}</td>
                        <td>{{ item.cheque_number }}</td>
                        <td>{{ item.bank_name }}</td>
                        <td>{{ item.brench }}</td>
                        <td>{{ item.price | currency('', 0, { symbolOnLeft: false }) }} ریال</td>
                        <td>{{ convertDateToJDate(item.due_date) }}</td>
                        <td>{{ getObjectNameById(categories.accounts,'account_id',item.account_id) }}</td>

                        <td>
                            <b v-if="item.is_revenue === '1'">بله</b>
                            <b v-else>خیر</b>
                        </td>
                        <td>{{ item.contact_id }}</td>
                        <td>
                            <b v-if="item.is_checkout === '1'">بله</b>
                            <b v-else>خیر</b>
                        </td>
                        <td>{{ item.description }}</td>
                        <td>
                            <v-icon
                            v-c-tooltip="'ویرایش'"                            
                                    medium
                                    @click="editItem(item,false)">
                                mdi-pencil
                            </v-icon>
                            <v-icon
                            v-c-tooltip="'حذف'"                            
                                    medium
                                    @click="deleteAccount(item)">
                                mdi-delete
                            </v-icon>
                            <v-icon
                            v-c-tooltip="'نمایش تاریخچه'"                            
                                    medium
                                    @click="showLogDialog(item)">
                                mdi-information
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </CCardBody>
    </CCard>
</template>

<script>
import {functionAction, getCategoryType, getFunction} from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons'
    import Switches from 'vue-switches';
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    import moment from "moment-jalaali";

    export default {
        name: 'Cheques',
        props: {},
        iconsSet,
        components: {
            Switches,
            datePicker: VuePersianDatetimePicker
        },
        methods: {
            getObjectNameById(list, key, id, extraKey) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i][key] === id) {
                        if (extraKey) {
                            return list[i].name + ' ' + list[i][extraKey]
                        }
                        return list[i].name
                    }
                }
            },
            convertDateToJDate(dt) {
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
            loadCategories() {

                getCategoryType(this.$http, 9).then((resp) => {
                  this.categories.categories = resp.list;
                  getFunction(this.$http, 'accounts', 0, 1000, 'sort_order', 'desc', {}).then((resp) => {
                    this.categories.accounts = resp.list;
                  });
                });

            },
            addItem() {
                this.editedItem = {
                    "cheque_id": "",
                    "cheque_number": "",
                    "is_revenue": "",
                    "bank_name": "",
                    "brench": "",
                    "price": "",
                    "account_id": "",
                    "description": "",
                    "bill_id": "",
                    "invoice_id": "",
                    "contact_id": "",
                    "pay_to_contact_id": "",
                    "is_checkout": "",
                    "due_date": "",
                    "sayad_number": ""
                };
                this.dialog = true
            },
            editItem(item) {
                this.editedIndex = this.cheques.indexOf(item);
                console.log("this.editedIndex.pay_to_contact_id:" + this.editedIndex.pay_to_contact_id + " this.pay_to_contact_active=" + this.pay_to_contact_active);
                this.editedItem = Object.assign({}, item);

                if(parseInt(this.editedItem.pay_to_contact_id) > 0)
                    this.pay_to_contact_active = "1";
                else
                    this.pay_to_contact_active = "0";

                console.log(this.editedItem);
                this.dialog = true
            },
            close() {
                this.dialog = false;
                Object.keys(this.validations).map((k) => {
                    this.validations[k] = {isValid: null, error: ''}
                });
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                })
            },
            save() {
                Object.keys(this.validations).map((key) => {
                    this.validations[key].error = '';
                    this.validations[key].isValid = null;
                });
                let action = this.editedIndex === -1 ? 'add' : 'update';
                functionAction(this.$http, 'cheques', action, this.editedItem).then((resp) => {
                    if (resp.success) {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshCheques();
                        this.close()
                    } else {
                        let errors = resp.body.errors;
                        Object.keys(errors).map((k) => {
                            this.validations[k] = {isValid: false, error: errors[k]}
                        });
                    }
                });
            },
            applyFilters() {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    } else {
                        filters[key] = `%${filters[key]}%`;
                    }
                });
                this.refreshCheques();
                this.filteredReq = filters;
            },
            resetFilters() {
                this.filters = {};
                this.refreshCheques();
                this.filteredReq = {}
            },
            deleteAccount(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {                 
                    Object.keys(item).map((key) => {
                        if (item[key] === null) {
                            item[key] = ''
                        }
                    });
                    functionAction(this.$http, 'cheques', 'delete', item).then((resp) => {
                        if (resp.success) {
                            this.$toasted.show(resp.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                            this.refreshCheques();
                        } else {
                            this.$toasted.show("اطلاعات ارسالی اشتباه است.", {
                                theme: "toasted-danger",
                                position: "bottom-center",
                                duration: 5000
                            });
                        }
                    });
                }
            },
            refreshCheques(fileType) {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    } else {
                        filters[key] = `%${filters[key]}%`;
                    }
                });
                getFunction(this.$http, 'cheques', (this.tableOption.page > 1) ? this.tableOption.itemsPerPage + this.tableOption.page + 1 : 0,
                    100, this.tableOption.sortedField, this.tableOption.sortDesc ? 'desc' : 'asc', filters, fileType).then((resp) => {
                    if (fileType !== undefined) {
                        if (fileType === 'pdf') {
                            window.open(resp.fileurl, '_blank');
                            return;
                        }
                        const link = document.createElement('a');
                        link.href = resp.fileurl;
                        link.setAttribute('download', 'revenues.' + ((fileType === 'pdf') ? 'pdf' : 'xls'));
                        document.body.appendChild(link);
                        link.click()
                    } else {
                        this.cheques = resp.list;
                        this.chequesCount = resp.count
                    }
                });
                this.filteredReq = filters;
            },
            showLogDialog(item) {
                this.logDialog = true;
                getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                    "code": "cheque",
                    "code_id": item.cheque_id
                }).then((resp) => {
                    this.selectedItemLogs = resp.list
                })
            }
        },
        data: () => {
            return {
                dialog: false,
                headers: [
                    {text: 'شناسه چک', value: 'cheque_id'},
                    {text: 'شماره چک', value: 'cheque_number'},
                    {text: 'نام بانک', value: 'bank_name'},
                    {text: 'شعبه', value: 'brench'},
                    {text: 'مبلغ', value: 'price'},
                    {text: 'تاریخ سر رسید', value: 'due_date'},
                    {text: 'حساب', value: 'account_id'},
                    {text: 'چک دریافتی', value: 'is_revenue'},
                    {text: 'شخص', value: 'contact_id'},
                    {text: 'پاس شده', value: '', sortable: false},
                    {text: 'توضیحات', value: 'description'},
                    {text: 'عملیات', value: 'actions', sortable: false}
                ],
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],
                cheques: [],
                chequesCount: 0,
                editedIndex: -1,
                editedItem: {
                    "cheque_id": "",
                    "cheque_number": "",
                    "is_revenue": "",
                    "bank_name": "",
                    "brench": "",
                    "price": "",
                    "account_id": "",
                    "description": "",
                    "bill_id": "",
                    "invoice_id": "",
                    "contact_id": "",
                    "pay_to_contact_id": "",                    
                    "is_checkout": "",
                    "due_date": "",
                    "sayad_number": ""
                },
                options: {},
                usersCategory: [],
                collapse: false,
                pay_to_contact_active: "0",
                filters: {},
                validations: {
                    cheque_number: {isValid: null, error: ''},
                    bank_name: {isValid: null, error: ''},
                    brench: {isValid: null, error: ''},
                    price: {isValid: null, error: ''},
                    description: {isValid: null, error: ''},
                    account_id: {isValid: null, error: ''},
                    bill_id: {isValid: null, error: ''},
                    contact_id: {isValid: null, error: ''},
                    pay_to_contact_id: {isValid: null, error: ''},
                    invoice_id: {isValid: null, error: ''},
                    is_checkout: {isValid: null, error: ''},
                    is_revenue: {isValid: null, error: ''}
                },
                tableOption: {
                    sortDesc: true,
                    sortedField: 'name',
                    itemsPerPage: 10,
                    page: 1
                },
                filteredReq: {},
                money: {
                    decimal: '',
                    thousands: ',',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },                
                categories: {
                    categories: [],
                    accounts: []
                },
                logDialog: false,
                selectedItemLogs: []
            }
        },
        mounted() {
            this.loadCategories();
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'چک جدید' : 'ویرایش چک'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            pay_to_contact_active(val){
                console.log("pay_to_contact_active" + val);
                if(val == '1'){
                    this.editedItem.account_id = '';
                }else{
                    this.editedItem.pay_to_contact_id = '';
                }
            },
            options: {
                handler(value) {
                    this.tableOption.sortedField = value['sortBy'][0];
                    this.tableOption.sortDesc = value['sortDesc'][0];
                    this.tableOption.itemsPerPage = value.itemsPerPage;
                    this.tableOption.page = value.page;
                    getFunction(this.$http, 'cheques', (value.itemsPerPage * (value.page -1)),
                        value.itemsPerPage,
                        value['sortBy'][0],
                        value['sortDesc'][0] ? 'desc' : 'asc',
                        this.filteredReq).then((resp) => {
                        this.cheques = resp.list;
                        this.chequesCount = resp.count
                    });
                },
                deep: true,
            },
        },
    }
</script>
